var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import { t } from '../../../../strings/i18n/i18n';
import { shallowEqual, useSelector } from 'react-redux';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { Content, Disclaimer, Header, MoreInfoImageContainer } from './subcomponents';
export var getPageAnalytics = function (isRedispute) {
    if (isRedispute) {
        return {
            pageKind: Analytics.Dispute,
            pageFunction: Analytics.Redispute,
            pageName: Analytics.Start
        };
    }
    return {
        pageKind: Analytics.Dispute,
        pageFunction: Analytics.CreditAlreadyIssued,
        pageSubFunction: Analytics.Questionnaire,
        pageName: Analytics.Start
    };
};
var Start = function () {
    var _a = useSelector(function (state) { return state; }, shallowEqual), assetsURL = _a.mfeConfig.assetsURL, isRedispute = _a.questionnaire.isRedispute;
    useEffect(function () {
        var pageAnalytics = getPageAnalytics(isRedispute);
        triggerAnalyticsEvent(pageAnalytics);
    }, [isRedispute]);
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    return (_jsxs(Content, __assign({ "data-cy": "questionnaire-start-screen" }, { children: [_jsx(MoreInfoImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "MORE_INFO", size: imageSize }) }), _jsx(Header, { children: isRedispute
                    ? t('questionnaire.doYouWantToRedispute')
                    : t('questionnaire.helpUsLearnMore') }), _jsx(Disclaimer, __assign({ "$isRedispute": isRedispute }, { children: isRedispute
                    ? t('questionnaire.ifSoWeWillReevaluate')
                    : t('questionnaire.youCanHelpUs') }))] })));
};
export default Start;
//# sourceMappingURL=index.js.map